import SearchQuery from '@/models/SearchQuery';
import ISearchQueryState from './interfaces/search-query-state.d';

export default class SearchQueryState implements ISearchQueryState {
    searchQuery: SearchQuery = new SearchQuery();
}
